require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-bs-ocaml-protoc-json.json") })
        }
      }, "path---package-bs-ocaml-protoc-json");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-bs-ocaml-protoc-json!./.cache/json/package-bs-ocaml-protoc-json.json
// module id = 812
// module chunks = 231608221292675